module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "row row-cols-lg-2 flex-lg-nowrap row-cols-1 d-flex"
  }, [(_vm.groupsDatesList.length > 0) ? _c('Select', {
    staticClass: "edu-level",
    attrs: {
      "options": _vm.groupsDatesList,
      "label": "Выберите желаемый период обучения",
      "large": true,
      "wide": true,
      "bold": false,
      "placeholder": "Выбрать период"
    },
    model: {
      value: (_vm.request.selectedGroupId),
      callback: function($$v) {
        _vm.$set(_vm.request, "selectedGroupId", $$v)
      },
      expression: "request.selectedGroupId"
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "form__fields mb-3"
  }, [_c('Select', {
    staticClass: "edu-level",
    attrs: {
      "required": "required",
      "options": _vm.eventOrderEduLevelsDict,
      "label": "Укажите место обучения на момент подачи заявки",
      "large": true,
      "wide": true,
      "bold": false,
      "placeholder": "Выбрать место обучения"
    },
    model: {
      value: (_vm.request.eduLevel),
      callback: function($$v) {
        _vm.$set(_vm.request, "eduLevel", $$v)
      },
      expression: "request.eduLevel"
    }
  })], 1), _c('div', {
    staticClass: "form__fields mb-3"
  }, [_c('Input', {
    staticClass: "mb-3 edu-level",
    attrs: {
      "placeholder": "Введите организацию",
      "label": "Организация, где учится или работает обучающийся на момент подачи заявки",
      "required": "required",
      "name": "organization_name"
    },
    model: {
      value: (_vm.request.organization_name),
      callback: function($$v) {
        _vm.$set(_vm.request, "organization_name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "request.organization_name"
    }
  })], 1), _c('div', {
    staticClass: "form__fields mt-auto"
  }, [(_vm.closeModal) ? _c('AppButtonNew', {
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("Отменить")]) : _vm._e(), _c('AppButtonNew', {
    attrs: {
      "disabled": _vm.isDisabled,
      "call-back-fn": _vm.submitRequest
    }
  }, [_vm._v("Отправить заявку")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0274f207","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ordersProcessForms/event/components/RequestForm.vue
// module id = d06770f4d81dff04c135
// module chunks = 5